var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid px-4 py-5"},[_c('div',{staticClass:"row"},[_c('div',{class:{ 'col-md-9': _vm.showMeta, 'col-md-12': !_vm.showMeta }},[_c('Accessibility')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }